import React from 'react'
import styled from 'styled-components'
import { ReactComponent as MenuSvg } from '../../../assets/icon/menu.svg'
import { ReactComponent as CloseSvg } from '../../../assets/icon/close.svg'
import { Text, View } from '../../../styles'
import { MENU_LIST } from '../../../mock'
import { ReactComponent as LogoSVG } from '../../../assets/logo/main.svg'

const NavigatorMobileComponent: React.FC<any> = () => {
  const [isVisible, setIsVisible] = React.useState(false)
  const toggleMenu = () => setIsVisible(!isVisible)
  return (
    <Wrap>
      <MenuSvg className='btn-menu' onClick={toggleMenu} />
      {isVisible && (
        <StyledNavigator>
          <LogoSVG className='title-logo' />
          <CloseSvg className='btn-close' onClick={toggleMenu} />

          {MENU_LIST.map((menu, idx) => (
            <StyledNavigatorItem key={idx} href={`#${menu.link}`} className='active'>
              <Text size='md'>{menu.label}</Text>
            </StyledNavigatorItem>
          ))}
        </StyledNavigator>
      )}
    </Wrap>
  )
}

export default NavigatorMobileComponent

const Wrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  .btn-menu {
    position: absolute;
    top: 55px;
    right: 34px;
    cursor: pointer;
  }

  .btn-close {
    position: absolute;
    top: 56px;
    right: 34px;
    cursor: pointer;
  }
`
const StyledNavigator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-height: 300px;
  padding: 55px 32px;
  background-color: var(--white-color);
  box-shadow: 0px 9px 4px rgba(0, 0, 0, 0.25);

  .title-logo {
    max-width: 103px;
    margin-bottom: 50px;
  }
`

const StyledNavigatorItem = styled.a`
  display: block;
  height: 36px;
  line-height: 36px;

  & + & {
    margin-top: 11px;
  }

  color: var(--gray-color-200);

  &:hover,
  .active {
    display: inline-block;
    color: var(--blue-color-100);
    vertical-align: middle;

    &::before {
      content: '';
      display: inline-block;
      width: 86px;
      height: 2px;
      background-color: var(--blue-color-100);
      vertical-align: middle;
      margin-right: 19px;
    }
  }
`
